module.exports = __webpack_public_path__ + "img/Date.de33e643.png";